/* =============================================
   NEON SIGN THEME — MAIN JS
   ============================================= */

(function () {
  'use strict';

  /* ---- Mobile sidebar ---- */
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const sidebar = document.getElementById('MobileSidebar');
  const overlay = document.getElementById('MobileSidebarOverlay');
  const closeBtn = document.querySelector('.mobile-sidebar-close');
  const capsuleBar = document.querySelector('.capsule-tab-bar');

  function setCapsuleHidden(hidden) {
    if (!capsuleBar) return;
    capsuleBar.style.opacity = hidden ? '0' : '';
    capsuleBar.style.pointerEvents = hidden ? 'none' : '';
    capsuleBar.style.transform = hidden ? 'translateY(-120%)' : '';
  }

  function isSidebarOpen() {
    return sidebar && sidebar.classList.contains('is-open');
  }

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    sidebar.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'true');
    setCapsuleHidden(true);
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'false');
    setCapsuleHidden(false);
    document.body.style.overflow = '';
  }

  toggleBtn && toggleBtn.addEventListener('click', openSidebar);
  closeBtn && closeBtn.addEventListener('click', closeSidebar);
  overlay && overlay.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSidebar();
  });

  /* ---- Mobile sign types accordion ---- */
  const signTypesToggle = document.querySelector('.mobile-sign-types-toggle');
  const signTypesPanel = document.getElementById('MobileSignTypes');
  const signTypesChevron = document.querySelector('.sign-types-chevron');

  signTypesToggle && signTypesToggle.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    signTypesPanel && signTypesPanel.classList.toggle('hidden');
    signTypesChevron && signTypesChevron.classList.toggle('rotate-180');
  });

  /* ---- Search overlay ---- */
  const searchToggle = document.querySelector('.search-toggle');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchCloseBtn = document.getElementById('searchCloseBtn');
  const searchInput = document.getElementById('searchInput');
  const searchResults = document.getElementById('searchResults');
  const searchTabs = document.getElementById('searchTabs');
  const tabAll = document.getElementById('tabAll');
  const tabProducts = document.getElementById('tabProducts');
  const tabPages = document.getElementById('tabPages');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    searchInput && setTimeout(() => searchInput.focus(), 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  searchToggle && searchToggle.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    expanded ? closeSearch() : openSearch();
  });
  searchCloseBtn && searchCloseBtn.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  /* ---- Predictive search ---- */
  if (searchInput && searchResults) {
    let activeFilter = 'all';
    let lastResults = { products: [], pages: [] };
    let debounceTimer = null;

    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function getImageUrl(img) {
      if (!img) return '';
      if (typeof img === 'string') return img;
      if (typeof img === 'object') return img.url || img.src || '';
      return '';
    }

    function renderResults() {
      const products = lastResults.products || [];
      const pages = lastResults.pages || [];

      tabAll && (tabAll.textContent = 'All (' + (products.length + pages.length) + ')');
      tabProducts && (tabProducts.textContent = 'Products (' + products.length + ')');
      tabPages && (tabPages.textContent = 'Pages (' + pages.length + ')');

      const showProducts = activeFilter === 'all' || activeFilter === 'product';
      const showPages = activeFilter === 'all' || activeFilter === 'page';

      let html = '';

      if (showProducts && products.length) {
        html += '<div class="search-result-group-label">Products</div>';
        products.forEach(function (p) {
          html += '<a class="search-result-item" href="' + p.url + '">'
            + '<span class="search-result-item__media">' + (p.featured_image ? '<img src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</span>'
            + '<span class="search-result-item__body">'
            + '<span class="search-result-item__title">' + escapeHtml(p.title) + '</span>'
            + '</span></a>';
        });
      }

      if (showPages && pages.length) {
        html += '<div class="search-result-group-label">Pages</div>';
        pages.forEach(function (pg) {
          html += '<a class="search-result-item" href="' + pg.url + '">'
            + '<span class="search-result-item__body">'
            + '<span class="search-result-item__title">' + escapeHtml(pg.title) + '</span>'
            + '</span></a>';
        });
      }

      searchResults.innerHTML = html || '<div class="search-empty">No results found.</div>';
    }

    function fetchPredictiveResults(query) {
      if (!query) {
        lastResults = { products: [], pages: [] };
        renderResults();
        return;
      }
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page&resources[limit]=10')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          const results = (data && data.resources && data.resources.results) || {};
          lastResults = {
            products: (results.products || [])
              .filter(function (p) { return !(p.tags || []).includes('hide-from-search'); })
              .map(function (p) {
                const img = getImageUrl(p.featured_image) || getImageUrl(p.image) || getImageUrl((p.images || [])[0]);
                return { title: p.title, url: p.url, featured_image: img, price: p.price_max_formatted || p.price_formatted || p.price || '' };
              }),
            pages: (results.pages || []).map(function (pg) {
              return { title: pg.title, url: pg.url };
            })
          };
          renderResults();
        })
        .catch(function () {
          searchResults.innerHTML = '<div class="search-empty">No results found.</div>';
        });
    }

    searchInput.addEventListener('input', function () {
      const query = this.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fetchPredictiveResults(query); }, 250);
    });

    searchTabs && searchTabs.addEventListener('click', function (e) {
      const btn = e.target.closest('.search-tab');
      if (!btn) return;
      searchTabs.querySelectorAll('.search-tab').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      activeFilter = btn.dataset.filter;
      renderResults();
    });
  }

  /* ---- Capsule tabs scroll ---- */
  const capsuleScrollBtn = document.querySelector('.capsule-scroll-btn');
  const capsuleScroll = document.querySelector('.capsule-tabs-scroll');

  capsuleScrollBtn && capsuleScrollBtn.addEventListener('click', function () {
    if (!capsuleScroll) return;
    capsuleScroll.scrollBy({ left: 320, behavior: 'smooth' });
  });

  if (capsuleScroll) {
    let capsuleIsDragging = false;
    let capsuleDidDrag = false;
    let capsuleDragStartX = 0;
    let capsuleDragStartScroll = 0;
    let capsuleDragResetTimer = null;

    function stopCapsuleDrag() {
      if (!capsuleIsDragging) return;
      capsuleIsDragging = false;
      capsuleScroll.classList.remove('is-dragging');
      capsuleScroll.style.cursor = 'pointer';
      document.body.style.userSelect = '';
      if (capsuleDidDrag) {
        capsuleDragResetTimer = window.setTimeout(function () {
          capsuleDidDrag = false;
        }, 250);
      }
    }

    capsuleScroll.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== undefined && event.button !== 0) return;

      capsuleDragStartX = event.clientX;
      capsuleDragStartScroll = capsuleScroll.scrollLeft;
      capsuleIsDragging = true;
      capsuleDidDrag = false;
      window.clearTimeout(capsuleDragResetTimer);
      capsuleScroll.classList.add('is-dragging');
      capsuleScroll.style.cursor = 'pointer';
    });

    window.addEventListener('pointermove', function (event) {
      if (!capsuleIsDragging) return;

      const dragDistance = event.clientX - capsuleDragStartX;
      if (Math.abs(dragDistance) > 12) {
        capsuleDidDrag = true;
        document.body.style.userSelect = 'none';
        event.preventDefault();
      }

      capsuleScroll.scrollLeft = capsuleDragStartScroll - (dragDistance * 2.4);
    });

    window.addEventListener('pointerup', stopCapsuleDrag);
    window.addEventListener('pointercancel', stopCapsuleDrag);
    capsuleScroll.addEventListener('dragstart', function (event) {
      if (!capsuleIsDragging) return;
      event.preventDefault();
    });

    capsuleScroll.addEventListener('click', function (event) {
      if (!capsuleDidDrag) return;

      event.preventDefault();
      event.stopPropagation();
      capsuleDidDrag = false;
      window.clearTimeout(capsuleDragResetTimer);
    }, true);
  }

  /* ---- Capsule tab active state ---- */
  const capsuleTabs = document.querySelectorAll('.capsule-tab');
  capsuleTabs.forEach(function (tab) {
    if (tab.getAttribute('href') === window.location.pathname) {
      tab.classList.add('is-active');
    }
  });

  if (capsuleScroll) {
    const activeCapsuleTab = capsuleScroll.querySelector('.capsule-tab.is-active');
    if (activeCapsuleTab) {
      window.requestAnimationFrame(function () {
        activeCapsuleTab.scrollIntoView({ inline: 'center', block: 'nearest' });
      });
    }
  }

  /* ---- Header always visible (sticky) ---- */
  const header = document.getElementById('SiteHeader');
  if (header) header.style.transform = 'translateY(0)';

  window.addEventListener('scroll', function () {
    setCapsuleHidden(isSidebarOpen());
  }, { passive: true });

  /* ---- Product page: thumbnail gallery ---- */
  const featuredImg = document.getElementById('ProductFeaturedImage');
  const thumbBtns = document.querySelectorAll('.thumbnail-btn');

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const src = this.dataset.src;
      if (featuredImg && src) {
        featuredImg.src = src;
      }
      thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* ---- Product page: qty stepper ---- */
  function initQtyStepper(container) {
    const minus = container.querySelector('.qty-minus');
    const plus = container.querySelector('.qty-plus');
    const input = container.querySelector('.qty-input, input[type="number"]');

    minus && minus.addEventListener('click', function () {
      if (!input) return;
      const val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val - 1);
    });

    plus && plus.addEventListener('click', function () {
      if (!input) return;
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  }

  document.querySelectorAll('.qty-selector').forEach(initQtyStepper);

  /* ---- Add to cart: AJAX (optional fallback) ---- */
  const productForm = document.getElementById('ProductForm');
  const addToCartBtn = productForm && productForm.querySelector('.add-to-cart-btn');

  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;

      const formData = new FormData(productForm);
      const data = {};
      formData.forEach(function (val, key) { data[key] = val; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          addToCartBtn.textContent = 'Added!';
          updateCartCount();
          setTimeout(function () {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          addToCartBtn.textContent = 'Add to Cart';
          addToCartBtn.disabled = false;
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  /* ---- Variant selection ---- */
  const variantInputs = document.querySelectorAll('[name^="options"]');
  const variantIdInput = document.getElementById('ProductVariantId');
  const priceEl = document.getElementById('ProductPrice');

  if (variantInputs.length && variantIdInput) {
    variantInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
  }

  function updateVariant() {
    const selected = {};
    variantInputs.forEach(function (i) {
      if (i.checked || i.type !== 'radio') {
        const name = i.name.replace('options[', '').replace(']', '');
        selected[name] = i.value;
      }
    });

    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        const match = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selected[product.options[i]];
          });
        });
        if (match) {
          variantIdInput.value = match.id;
          if (priceEl) {
            priceEl.textContent = formatMoney(match.price);
          }
          if (addToCartBtn) {
            addToCartBtn.disabled = !match.available;
            addToCartBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- GTM / dataLayer form tracking ---- */
  window.dataLayer = window.dataLayer || [];

  function cleanTrackingPayload(payload) {
    const clean = {};
    Object.keys(payload || {}).forEach(function (key) {
      const value = payload[key];
      if (value !== undefined && value !== null && value !== '') clean[key] = value;
    });
    return clean;
  }

  function getPagePayload(extra) {
    return cleanTrackingPayload(Object.assign({
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_referrer: document.referrer || '',
      store_id: 'fineyst-signs-shopify'
    }, extra || {}));
  }

  function pushTrackingEvent(eventName, payload) {
    const cleanPayload = cleanTrackingPayload(payload || {});
    window.dataLayer.push(Object.assign({ event: eventName }, cleanPayload));

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, cleanPayload);
    }
  }

  function trackPageView(extra) {
    pushTrackingEvent('page_view', getPagePayload(extra));
  }

  function trackAddToCart(item) {
    pushTrackingEvent('add_to_cart', cleanTrackingPayload(Object.assign({
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '',
      page_location: window.location.href,
      page_path: window.location.pathname,
      store_id: 'fineyst-signs-shopify'
    }, item || {})));
  }

  function trackBeginCheckout(cart) {
    pushTrackingEvent('begin_checkout', cleanTrackingPayload(Object.assign({
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '',
      page_location: window.location.href,
      page_path: window.location.pathname,
      store_id: 'fineyst-signs-shopify'
    }, cart || {})));
  }

  function normalizeCartItem(item) {
    if (!item || typeof item !== 'object') return {};
    return cleanTrackingPayload({
      item_id: item.product_id || item.id || item.variant_id || '',
      item_variant_id: item.variant_id || item.id || '',
      item_name: item.product_title || item.title || '',
      item_variant: item.variant_title || '',
      item_brand: item.vendor || '',
      price: typeof item.final_price === 'number' ? item.final_price / 100 : (typeof item.price === 'number' ? item.price / 100 : ''),
      quantity: item.quantity || 1
    });
  }

  function cartPayloadFromCart(cart) {
    if (!cart || typeof cart !== 'object') return {};
    const items = Array.isArray(cart.items) ? cart.items.map(normalizeCartItem) : [];
    return cleanTrackingPayload({
      value: typeof cart.total_price === 'number' ? cart.total_price / 100 : '',
      item_count: cart.item_count || items.reduce(function (total, item) { return total + (Number(item.quantity) || 0); }, 0),
      items: items
    });
  }

  function initCommerceTracking() {
    trackPageView();

    if (window.fetch && !window.__fineystFetchTrackingPatched) {
      const nativeFetch = window.fetch;
      window.__fineystFetchTrackingPatched = true;
      window.fetch = function () {
        const args = arguments;
        const request = args[0];
        const url = typeof request === 'string' ? request : (request && request.url) || '';
        const isCartAdd = /\/cart\/add\.js(?:\?|$)/.test(url);

        return nativeFetch.apply(this, args).then(function (response) {
          if (isCartAdd && response && response.ok) {
            response.clone().json().then(function (item) {
              trackAddToCart({ items: [normalizeCartItem(item)] });
            }).catch(function () {
              trackAddToCart();
            });
          }
          return response;
        });
      };
    }

    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!form || form.nodeName !== 'FORM') return;
      const submitter = event.submitter;
      const isCheckoutSubmit = (submitter && submitter.name === 'checkout') || form.querySelector('[name="checkout"]:focus');
      if (!isCheckoutSubmit) return;

      if (window.__fineystBeginCheckoutTracked) return;
      window.__fineystBeginCheckoutTracked = true;

      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) { trackBeginCheckout(cartPayloadFromCart(cart)); })
        .catch(function () { trackBeginCheckout(); });
    }, true);
  }
  function trackFormSubmission(formType, formData) {
    const cleanFormData = cleanTrackingPayload(formData || {});
    const eventName = formType + '_submitted';
    const basePayload = cleanTrackingPayload(Object.assign({
      form_type: formType,
      form_name: cleanFormData.form_name || formType,
      element_id: cleanFormData.element_id || '',
      element_class: cleanFormData.element_class || 'form-submit-button',
      user_email: cleanFormData.user_email || cleanFormData.email || '',
      user_phone: cleanFormData.user_phone || cleanFormData.phone || cleanFormData.contactNo || '',
      user_name: cleanFormData.user_name || cleanFormData.name || ''
    }, cleanFormData));

    window.dataLayer.push(Object.assign({
      event: eventName,
      gtm: {
        uniqueEventId: Date.now(),
        start: Date.now()
      }
    }, basePayload));

    window.dataLayer.push(Object.assign({ event: 'lead' }, basePayload));

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, basePayload);
      window.gtag('event', 'lead', basePayload);
    }
  }

  function trackFormStart(formType, formData) {
    const cleanFormData = cleanTrackingPayload(formData || {});
    window.dataLayer.push(Object.assign({
      event: formType + '_started',
      form_type: formType,
      form_name: cleanFormData.form_name || formType
    }, cleanFormData));
  }

  window.FineystTracking = Object.assign(window.FineystTracking || {}, {
    trackFormSubmission: trackFormSubmission,
    trackFormStart: trackFormStart,
    trackPageView: trackPageView,
    trackAddToCart: trackAddToCart,
    trackBeginCheckout: trackBeginCheckout
  });


  initCommerceTracking();

})();
